/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrerrorcorrection2Inputs */

const en_qrerrorcorrection2 = /** @type {(inputs: Qrerrorcorrection2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error correction`)
};

const de_qrerrorcorrection2 = /** @type {(inputs: Qrerrorcorrection2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlerkorrektur`)
};

/**
* | output |
* | --- |
* | "Error correction" |
*
* @param {Qrerrorcorrection2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrerrorcorrection2 = /** @type {((inputs?: Qrerrorcorrection2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrerrorcorrection2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrerrorcorrection2(inputs)
	return de_qrerrorcorrection2(inputs)
});
export { qrerrorcorrection2 as "qrErrorCorrection" }